import * as Yup from 'yup';

export const addBillingAddressModalSchema = Yup.object().shape({
  billingIdCode: Yup.string().required('Billing ID / Code is required'),
  emailId: Yup.string().email('Invalid email format'),
  addressLineOne: Yup.string().required('Address is required'),
  zipCode: Yup.string().required('Zip / Postal Code is required'),
});
